export default {
  overview_ncbdtx_by_module: '/ncbdtx/api/ncbdtx-by-module-report',
  details_ncbdtx_by_module: '/ncbdtx/api/get-detail-ncbdtx-by-module-report',
  export_details_ncbdtx_by_module:
    '/ncbdtx/api/export-detail-ncbdtx-by-module-report',
};
